import colors from 'quasar/src/utils/colors.js';import setCssVar from 'quasar/src/utils/set-css-var.js';import Dark from 'quasar/src/plugins/Dark.js';
import {getToken} from "@/helpers/lostForm";

export function fieldIsVisible(field) {
    let visible = true;
    if(field.logic) {
        visible = false;
    }
    return visible;
}
export function screenIsVisible (screen) {
    let visible = false;
    for(let key in screen.fields) {
        if(fieldIsVisible(screen.fields[key])) {
            visible = true
            break;
        }
    }
    return visible
}


export function getScreenValuesFromForm(form, fieldValues) {
    let screens = {};
    for(let key in form.screens) {
        const screen = form.screens[key];
        const visible = screenIsVisible(screen, fieldValues);

        screens[screen.id] = {
            'visible' : visible
        };
    }
}

export function getStartingFieldValuesFromForm(form) {
    let fields = {};
    for(let key in form.screens) {
        for(let keyF in form.screens[key].fields) {
            const field = form.screens[key].fields[keyF];
            fields[field.id] = field.default ? field.default : null;
        }
    }
    return fields;
}

//export function getFieldsVisibilityFromForm(form, fieldValues) {
export function getFieldsVisibilityFromForm(form, fieldValues) {
    let fields = {};
    for(let key in form.screens) {
        for(let keyF in form.screens[key].fields) {
            const field = form.screens[key].fields[keyF];

            let visible = true;
            if(field.logic && field.logic.visible) {
                for(let fieldNameLogicBy in field.logic.visible) {
                    const logic = field.logic.visible[fieldNameLogicBy];
                    const fieldLogicBy = getFieldByType(form, fieldNameLogicBy);
                    if(fieldLogicBy && fieldValues[fieldLogicBy.id] !== logic.value) {
                        visible = false;
                    }
                }
            }

            fields[field.id] = visible;
        }
    }
    return fields;
}
export function getFieldByType(form, name) {
    for(let key in form.screens) {
        const screen = form.screens[key];
        for(let keyF in screen.fields) {
            const field = screen.fields[keyF];
            if(name === field.type) {
                return field
            }
        }
    }
    return null;
}

export function getScreensVisibilityFromForm(form, fieldsVisibility) {
    let screens = {};
    for(let key in form.screens) {
        let visible = false;
        const screen = form.screens[key];
        for(let keyF in screen.fields) {
            const field = screen.fields[keyF];
            if(fieldsVisibility[field.id]) {
                visible = true;
                break;
            }
        }
        screens[screen.id] = visible;
        //TODO implement logic
    }
    return screens;
}



export function getRealValue(field, values) {
    return values[field.id]
}
// field values is set on mount
// field visibility watch from Values
// screen visibility watch from field visible Values

export function theme(settings) {
    const { lighten } = colors;
    const newPrimaryColor = settings.theme.colors.primary;
    if(newPrimaryColor !== "primary") {
        setCssVar('primary', newPrimaryColor);
        setCssVar('primary-darkened', lighten(newPrimaryColor, -10));
    }

    const newSecondaryColor = settings.theme.colors.secondary;
    if(newSecondaryColor !== "secondary") {
        setCssVar('secondary', newSecondaryColor);
        setCssVar('secondary-darkened', lighten(newSecondaryColor, -10));
    }

    const newDarkColor = settings.theme.colors.dark;
    if(newDarkColor !== "dark") {
        setCssVar('dark', newDarkColor);
    }

    const newDarkPageColor = settings.theme.colors.darkPage;
    if(newDarkPageColor !== "darkPage") {
        setCssVar('dark-page', newDarkPageColor);
    }

    if(settings.theme.next.colors.primary) {
        setCssVar('fb-next-colors-primary', settings.theme.next.colors.primary);
    }
    if(settings.theme.next.colors.border) {
        setCssVar('fb-next-colors-border', settings.theme.next.colors.border);
    }
    if(settings.theme.next.colors.hover) {
        setCssVar('fb-next-colors-hover', settings.theme.next.colors.hover);
    }
    if(settings.theme.next.colors.hover_border) {
        setCssVar('fb-next-colors-hover_border', settings.theme.next.colors.hover_border);
    }
    if(settings.theme.next.colors.text) {
        setCssVar('fb-next-colors-text', settings.theme.next.colors.text);
    }
    if(settings.theme.next.colors.text_hover) {
        setCssVar('fb-next-colors-text_hover', settings.theme.next.colors.text_hover);
    }

    if(settings.theme.back.colors.primary) {
        setCssVar('fb-back-colors-primary', settings.theme.back.colors.primary);
    }
    if(settings.theme.back.colors.border) {
        setCssVar('fb-back-colors-border', settings.theme.back.colors.border);
    }
    if(settings.theme.back.colors.hover) {
        setCssVar('fb-back-colors-hover', settings.theme.back.colors.hover);
    }
    if(settings.theme.back.colors.hover_border) {
        setCssVar('fb-back-colors-hover_border', settings.theme.back.colors.hover_border);
    }
    if(settings.theme.back.colors.text) {
        setCssVar('fb-back-colors-text', settings.theme.back.colors.text);
    }
    if(settings.theme.back.colors.text_hover) {
        setCssVar('fb-back-colors-text_hover', settings.theme.back.colors.text_hover);
    }


    if(settings.theme.button.colors.primary) {
        setCssVar('fb-button-colors-primary', settings.theme.button.colors.primary);
    }
    if(settings.theme.button.colors.active) {
        setCssVar('fb-button-colors-active', settings.theme.button.colors.active);
    }
    if(settings.theme.button.colors.border) {
        setCssVar('fb-button-colors-border', settings.theme.button.colors.border);
    }
    if(settings.theme.button.colors.hover) {
        setCssVar('fb-button-colors-hover', settings.theme.button.colors.hover);
    }
    if(settings.theme.button.colors.hover_border) {
        setCssVar('fb-button-colors-hover_border', settings.theme.button.colors.hover_border);
    }
    if(settings.theme.button.colors.text) {
        setCssVar('fb-button-colors-text', settings.theme.button.colors.text);
    }
    if(settings.theme.button.colors.text_hover) {
        setCssVar('fb-button-colors-text_hover', settings.theme.button.colors.text_hover);
    }

    if(settings.theme.dark === true) {
        Dark.set(true)
    }
}

export function fetchEnv(route, data) {
    let url = route;
    if(window.location.href.indexOf("localhost") >= 0) {
        url = "http://localhost:9001/app_dev.php" + route;
    }
    return fetch(url,
        {
            method: 'POST',
             //credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        .then(
            response => response.json()
        );
}

export function fetchDomain(route, form, data) {
    const domain = (form.domain === 'https://mortgageware.dev' ? 'http://localhost:9001/app_dev.php' : form.domain);
    let url = domain + route;
    return fetch(url,
        {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        .then(
            response => response.json()
        );
}

export function sendData(form, values, token, fieldsVisibility) {
    const domain = (form.domain === 'https://mortgageware.dev' ? 'http://localhost:9001/app_dev.php' : form.domain);
    //const domain = 'http://localhost:9001/app_dev.php'
    let url = domain + '/forms/send/' + form.route;

    const fields = {};
    const custom = {};

    let pageUrl = window.location.href;
    if(window.self !== window.top){
        try {
            pageUrl = window.top.location.href;
        } catch (e) {
            console.log(e);
        }
    }
    custom.domain = domain;
    custom.uri = pageUrl;
    for(let key in form.screens) {
        for (let keyF in form.screens[key].fields) {
            const field = form.screens[key].fields[keyF];
            if(fieldsVisibility[field.id]) {
                if(field.custom) {
                    custom[field.type] = values[field.id];
                } else {
                    fields[field.type] = values[field.id];
                }
            }
        }
    }
    if(values['loan_type_prefill']) {
        custom['loan_type_prefill'] = values['loan_type_prefill'];
    }
    if(values['passed_params']) {
        custom['passed_params'] = values['passed_params'];
    }
    let type = form.type_route;
    //type = 'loan';
    return fetch(url,
        {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                fields,
                custom,
                token,
                type,
                lostFormToken: getToken(form)
            })
        })
        .then(
            response => response.json()
        );
}

export async function getRedirectParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const redirect = urlParams.get('redirect');
    const current_domain = window.location.hostname;
    const domain = (current_domain === 'localhost' ? 'http://localhost:9001/app_dev.php' : 'https://' + current_domain);
    //const domain = 'http://localhost:9001/app_dev.php'
    let url = domain + '/front/api/v1/redirect';

    const response = await fetch(url,
        {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                redirect: redirect
            })
        })
    const urlRedirect = await response.json();
    return urlRedirect;
}
export function sendDataLostForm(
    form, values, token, fieldsVisibility,
    hash,
    checksum,
    activeScreen
) {
    const domain = (form.domain === 'https://mortgageware.dev' ? 'http://localhost:9001/app_dev.php' : form.domain);
    //const domain = 'http://localhost:9001/app_dev.php'
    let url = domain + '/lost_form_v2/' + form.route;

    const fields = {};
    const custom = {};

    let pageUrl = window.location.href;
    if(window.self !== window.top){
        try {
            pageUrl = window.top.location.href;
        } catch (e) {
            console.log(e);
        }
    }
    custom.domain = domain;
    custom.uri = pageUrl;
    for(let key in form.screens) {
        for (let keyF in form.screens[key].fields) {
            const field = form.screens[key].fields[keyF];
            if(fieldsVisibility[field.id]) {
                if(field.custom) {
                    custom[field.type] = values[field.id];
                } else {
                    fields[field.type] = values[field.id];
                }
            }
        }
    }
    let type = form.type_route;
    //type = 'loan';
    return fetch(url,
        {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                data: {
                    fields,
                    custom
                },
                token,
                type,
                hash,
                checksum,
                values,
                activeScreen
            })
        })
        .then(
            response => response.json()
        );
}


export function getFieldByFieldType  (form, type) {
    for(let key in form.screens) {
        for (let keyF in form.screens[key].fields) {
            const field = form.screens[key].fields[keyF];
            if(type === field.type) {
                return field;
            }
        }
    }
    return null;
}

